export interface IIdentificationDocument {
  type: string;
  value: string;
}

export interface IUserData {
  email: string;
  name: string;
  surname: string;
  surname2: string;
  prefixNumber: string;
  phoneNumber: string;
  day: string;
  month: string;
  year: string;
  identificationDocument: IIdentificationDocument;
  associatedAdult?: string;
}

export enum EPassengerFormVariant {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  BABY = 'BABY',
}

export interface IFamilyCard {
  id: string;
  title: string;
  description: string;
  percentageDiscount: number;
  discountAllTrainForPerson: number;
}

export interface IPassengerList {
  userData: IUserData;
  isOpen: boolean;
  passengerName: string;
  isValidForm: boolean;
  accordionId: EPassengerFormVariant;
  discountData?: any;
  generalCard: IFamilyCard;
  specialCard: IFamilyCard;
}

export interface BodyExtrasCall {
  tariffs: Array<BodyExtrasObj>;
}
export interface BodyExtrasObj {
  passengerType?: string;
  context: string;
}

export interface Complement {
  codComplement: string;
  nameComplement: string;
  descComplement: string;
  numMaxSelection: string;
  asignationType: string;
  price: string;
}

export interface ResponseExtrasCall {
  tariffs: Array<TariffsExtras>;
}

export interface TariffsExtras {
  counter: number;
  tariff: string;
  context: string;
  passengerType: string;
  complements: Complement[];
}
export enum ELargeFamilyCardEnum {
  GENERAL = '070',
  ESPECIAL = '072',
}

export interface IExtraBoxObj {
  codComplement: string;
  nameComplement: string;
  descComplement: string;
  numMaxSelection: string;
  asignationType: string;
  price: string;
  passengers: Array<string>;
}
export interface IRenfeHeader {
  title: string;
  aveId: string;
  firstLocation: string;
  middleLocation: string;
  lastLocation: string;
}
export interface ExtrasList {
  renfeHeader: IRenfeHeader;
  cardsSection: IExtraBoxObj[];
}
export interface TripList {
  type: string;
  seatingList: Array<ExtrasList>;
}

export interface ExtraData {
  tripIndex:any
  id: string,
  name: string,
  ammount: number,
  body: {
    type: string,
    value: string
  }
}

export interface ISeatData {
  id: string,
  name: string,
  ammount: number,
  body: {
    type: string,
    value: string
  }[]
}

export interface ExtrasSelected {
  departureSectionData: {
    type: string;
    isValidSection: boolean;
    extrasSelected: Array<any>;
  },
  returnSectionData: {
    type: string;
    isValidSection: boolean;
    extrasSelected: Array<ExtraSelectedObject>;
  }
}
export interface ExtraSelectedObject {
  extra: string;
  headerVariant: string;
  index: number;
  numPassengers: number;
  passengers: Array<string>;
  pricePerPassenger: string;
  totalPrice: number;
  type: string;
}

export enum ESeatingTypes {
  CHOISE_INDIFERENT = "CHOISE_INDIFERENT",
  SEAT = "SEAT",
  CHOISE_WINDOW = "CHOISE_WINDOW",
  CHOISE_HALLWAY = "CHOISE_HALLWAY"
}

export enum EDiscoutCardEnum {
  MASRENFE = 'MASRENFE',
  DORADA = 'DORADA',
  JOVEN = 'JOVEN',
  '4OMAS' = '4OMAS'
}